import $ from 'jquery';
import {dependency} from "../../utils/request";

export default function countUpDirective(context=document.body) {
	const $counts = $('[sw-count]');
	if ($counts.length) {
		const url = 'https://cdn.jsdelivr.net/npm/countup@1.8.2/dist/countUp.js';
		dependency(url, window.CountUp && CountUp).then(function () {
			$counts.each(function () {
				const $this = $(this);
				const data = JSON.parse($this.attr('sw-count'));
				const val = $this.html();
				let count = null;

				if (Object.keys(data).length) {
					count = new CountUp(this, 0, val, 0, 2, data);
				} else {
					count = new CountUp(this, 0, val);
				}

				if (count) {
					if ($this.hasClass('is-revealed')) {
						count.start();
					}

					$this.on('cssRevealed', function () {
						count.start();
					});
				}
			});
		});
	}
}



// WEBPACK FOOTER //
// ./source/scripts/directives/scroll/countUp.js